module.exports = __webpack_public_path__ + "img/biaoz.56023a7b.png";